import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './Styles/tailwind.css';

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: Add performance measuring
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// Uncomment below if you have web vitals setup
// import reportWebVitals from './reportWebVitals';
// reportWebVitals();